import axios from "axios";

import Config from "src/config";

const v2_actionListaTagsChats = (querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chats/tags/lista${querys}`
    });
};
export default v2_actionListaTagsChats;
